import { render } from "./PDialog.vue?vue&type=template&id=756ce1a8"
import script from "./PDialog.vue?vue&type=script&lang=js"
export * from "./PDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__